import React, { Component } from 'react';
import { FirebaseContext } from './firebase/Context'

export class ProductAdm extends Component {
    static displayName = ProductAdm.name;
    static contextType = FirebaseContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            products: []

        }
        this.renderProducts = this.renderProducts.bind(this);
    };

    async populateProductsData() {
        const response = await fetch('api/Product/GetAll');
        const data = await response.json();
        this.setState({ products: data, loading: false });
    };


    componentDidMount() {
        this.populateProductsData();
    };

    handlerEditProduct(code) {
        const product = this.state.products.find(p => p.code === code);
        this.props.history.push({
            pathname: '/product-edit',
            state: {
                product: product
            }
        });
    }

    handlerRemoveProduct(code) {

        fetch('api/Product/Delete/' + code, {
            method: 'DELETE'
        })
            .then(response => response.json())
            .then(data => {
                if (JSON.stringify(data) === '1') {
                    var data = this.state.products;
                    const element = data.find(e => e.code === code);
                    var i = data.indexOf(element);
                    data.splice(i, 1);
                    this.setState({
                        products: data
                    });
                }
                else
                    window.alert("Ocurrio un error");
            }
            );
    }

    handlerAddProduct() {
        this.props.history.push({
            pathname: '/product-edit'
        });
    }

    renderProducts(products) {
        return (

            <table className='table'>
                <thead>
                    <tr>
                        <th>Codigo</th>
                        <th>Titulo</th>
                        <th></th>
                        <th></th>
                        <th colSpan="3">
                            <button className="btn-info" onClick={() => this.handlerAddProduct()}>
                                Agregar
                            </button></th>

                    </tr>
                </thead>
                <tbody>
                    {products.map(p =>
                        <tr key={p.code}>
                            <td>{p.code}</td>
                            <td>{p.title}</td>
                            <td>
                                <button
                                    className="btn-info"
                                    onClick={() => this.handlerEditProduct(p.code)}
                                >
                                    Editar
                                </button>
                            </td>
                            <td><button
                                className="btn-danger"
                                onClick={() => this.handlerRemoveProduct(p.code)}
                            >
                                Eliminar
                            </button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

        );

    };

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderProducts(this.state.products);

        return (
            <div>
                <h1>Administracion de productos</h1>
                <div className="container">
                    <div className="row">
                        {contents}
                    </div>
                </div>
            </div>
        );
    }
}
